// filepath: /src/js/components/search.js
class SearchFunctionality {
  constructor() {
    // Removed console.log for production
    this.searchInput = document.getElementById('searchQuery');
    this.searchTrigger = document.querySelector('[data-search-trigger]');
    this.searchOverlay = document.querySelector('[data-search-overlay]');
    this.searchClose = document.querySelector('[data-search-close]');
    this.headerIcons = document.querySelectorAll('.header__icons .header__icon');
    this.header = document.querySelector('[data-header]');
    
    this.lastScrollPos = window.pageYOffset;
    
    if (this.searchTrigger && this.searchOverlay) {
      this.initEventListeners();
    }
  } 
  initEventListeners() {
    // Toggle search overlay when clicking search icon
    if (this.searchTrigger && this.searchOverlay) {
      this.searchTrigger.addEventListener('click', this.toggleSearchOverlay.bind(this));
    }
    
    // Close search overlay when clicking close button
    if (this.searchClose) {
      this.searchClose.addEventListener('click', this.closeSearchOverlay.bind(this));
    }
    
    // Close when clicking outside search area
    document.addEventListener('click', this.handleDocumentClick.bind(this));
    
    // Close when pressing ESC key
    document.addEventListener('keydown', this.handleKeyDown.bind(this));
    
    // Close on scroll in mobile
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    // Close when clicking other header elements
    if (this.headerIcons && this.headerIcons.length > 0) {
      this.headerIcons.forEach(icon => {
        if (!icon.hasAttribute('data-search-trigger')) {
          icon.addEventListener('click', this.closeSearchOverlay.bind(this));
        }
      });
    }
    
    // Listen for page navigation
    window.addEventListener('popstate', this.closeSearchOverlay.bind(this));
  }
  
  toggleSearchOverlay(e) {
    if (e) e.preventDefault();
    
    if (this.isSearchOverlayActive()) {
      this.closeSearchOverlay();
    } else {
      this.openSearchOverlay();
    }
  }
  
  openSearchOverlay() {
    if (!this.searchOverlay) return;
    
    this.searchOverlay.classList.add('active');
    document.body.classList.add('search-active');
    
    // Focus search input after brief delay for animation
    if (this.searchInput) {
      setTimeout(() => {
        this.searchInput.focus();
      }, 150);
    }
  }
  
  closeSearchOverlay() {
    if (!this.searchOverlay) return;
    
    this.searchOverlay.classList.remove('active');
    document.body.classList.remove('search-active');
  }
  
  isSearchOverlayActive() {
    return this.searchOverlay && this.searchOverlay.classList.contains('active');
  }
  
  handleKeyDown(e) {
    if (e.key === 'Escape' && this.isSearchOverlayActive()) {
      this.closeSearchOverlay();
    }
  }
  
  handleScroll() {
    // Only handle scroll on mobile devices
    if (window.innerWidth <= 768) {
      const currentScrollPos = window.pageYOffset;
      
      // Close search if scrolling up or down
      if (Math.abs(this.lastScrollPos - currentScrollPos) > 10 && this.isSearchOverlayActive()) {
       // this.closeSearchOverlay();
      }
      
      this.lastScrollPos = currentScrollPos;
    }
  }
  
  handleDocumentClick(event) {
    // Close search if click is outside search area and search overlay is active
    if (this.isSearchOverlayActive() && 
        !event.target.closest('[data-search-overlay]') && 
        !event.target.closest('[data-search-trigger]')) {
      this.closeSearchOverlay();
    }
  }
}

// Export as default for ES6 modules
export default SearchFunctionality;

// Also export as SearchPanel for compatibility
export { SearchFunctionality as SearchPanel };

// CommonJS export for webpack compatibility
if (typeof module !== 'undefined' && module.exports) {
  module.exports = SearchFunctionality;
  module.exports.SearchPanel = SearchFunctionality;
  module.exports.default = SearchFunctionality;
}
